export const constants = {
    toolsTypes: {
        HEADER: {
            code: 'header',
            label: 'Page Header',
            height: 4,
        },
        PAGE_SECTION: {
            code: 'pageSection',
            label: 'Page Section',
            height: 3,
        },
    },
}
